import { render } from "./hyqz.vue?vue&type=template&id=2d4b415c&scoped=true&ts=true"
import script from "./hyqz.vue?vue&type=script&lang=ts"
export * from "./hyqz.vue?vue&type=script&lang=ts"

import "./hyqz.vue?vue&type=style&index=0&id=2d4b415c&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4b415c"]])

export default __exports__